import { render } from "./TopInfo.vue?vue&type=template&id=4faa4e61"
import script from "./TopInfo.vue?vue&type=script&lang=js"
export * from "./TopInfo.vue?vue&type=script&lang=js"

import "./TopInfo.vue?vue&type=style&index=0&id=4faa4e61&lang=scss"

import exportComponent from "G:\\司机仓库\\warehouseModule\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__